export default __webpack_public_path__ + "static/media/Jenna.eb5604a2.jpg";